import { ErrorRes } from "@/dto/HttpDto.ts";

class HttpException extends Error {
    private readonly error: ErrorRes;

    constructor(error: ErrorRes) {
        super(error.message);
        this.error = error;
        this.message = error.message;
    }

    public getError(): ErrorRes {
        return this.error;
    }
}

export default HttpException;
